document.querySelectorAll( '.b-image-people-tabs' ).forEach( ( block ) => {

	const personTabs = block.querySelectorAll( '.c-person-tab' );
	if ( !personTabs.length ) {

		return;

	}

	/**
	 * Toggles the active state of the personTab and contentTab elements while removing the active state from all other elements with the specified classes.
	 *
	 * @param {Element} personTab - The element representing the person tab to be toggled as active.
	 * @param {Element} contentTab - The element representing the content tab to be toggled as active.
	 */
	const toggleTab = ( personTab, contentTab ) => {

		block.querySelectorAll( '.c-person-tab.c-person-tab--active' )
			.forEach( el => el.classList.remove( 'c-person-tab--active' ) );

		block.querySelectorAll( '.b-image-people-tabs-item.b-image-people-tabs-item--active' )
			.forEach( el => el.classList.remove( 'b-image-people-tabs-item--active' ) );

		personTab.classList.add( 'c-person-tab--active' );
		contentTab.classList.add( 'b-image-people-tabs-item--active' );

	};

	/**
	 * Handles the click event on a tab element.
	 * Finds the corresponding content tab element and toggles visibility.
	 * Also removes 'init' class from the parent block element.
	 *
	 * @param {Event} event - The click event
	 */
	const handleTabClick = ( event ) => {

		const personTab = event.target.closest( '.c-person-tab' );
		if ( !personTab ) {

			return;

		}

		if ( personTab.classList.contains( 'c-person-tab--active' ) ) {

			return;

		}

		const personTabIndex = personTab.dataset.index;
		const tabContent = block.querySelector(
			`.b-image-people-tabs-item[data-index="${ personTabIndex }"]`
		);
		if ( !tabContent ) {

			return;

		}

		toggleTab( personTab, tabContent );

	};

	block.addEventListener( 'click', handleTabClick );

} );
